module.exports = __webpack_public_path__ + "img/video-icon.39eacbc4.svg";